


























































































import { Vue } from "@/app"

export default Vue.extend({
  name: "StartSelling",
  props: {
    investment: { type: Object, required: true },
  },
  // emits: ["success", "close"], // TODO this line should definitely be here?
  data() {
    return {
      validatePercentRules: [
        (v) => !isNaN(parseFloat(v)) || this.$t('startSelling.errors.hasToBeNumber'),
        (v) => isFinite(parseFloat(v)) || this.$t('startSelling.errors.hasToBeNumber'),
        (v) => parseFloat(v) > -100 || this.$t('startSelling.errors.hasToBeGreaterThan100'),
      ],
      validateRules: [
        (v) => !isNaN(parseFloat(v)) || this.$t('startSelling.errors.hasToBeNumber'),
        (v) => isFinite(parseFloat(v)) || this.$t('startSelling.errors.hasToBeNumber'),
        (v) => parseFloat(v) > 0 || this.$t('startSelling.errors.hasToBePositiveNumber'),
      ],
      valid: true,
      amount: 0,
      amountPercent: 0,
      confirmDialog: false,
      loading: false,
    }
  },
  computed: {
    outstandingPrincipal() {
      return this.investment.outstanding_principal
    },
    percentColoring() {
      if (this.amountPercent < 0) {
        return 'text-red'
      }
      if (this.amountPercent > 0) {
        return 'text-green'
      }
      return ''
    },
    amountNum() {
      return parseFloat(this.amount) || 0
    },
    amountPercentNum() {
      return parseFloat(this.amountPercent) || 0
    },
  },
  created() {
    this.amount = this.outstandingPrincipal
    this.amount = this.amount.toFixed(2)
  },
  methods: {
    percentChanged() {
      this.amount = (this.amountPercentNum + 100) / 100 * this.outstandingPrincipal
      this.amount = this.amount.toFixed(2)
    },
    amountChanged() {
      this.amountPercent = (this.amountNum / this.outstandingPrincipal * 100) - 100
      this.amountPercent = this.amountPercent.toFixed(2)
    },
    percentPlus() {
      this.amountPercent = this.amountPercentNum + 0.5
      this.amountPercent = this.amountPercent.toFixed(2)
      this.percentChanged()
    },
    percentMinus() {
      this.amountPercent = this.amountPercentNum - 0.5
      this.amountPercent = this.amountPercent.toFixed(2)
      this.percentChanged()
    },
    closeInside() {
      Vue.nextTick().then(() => this.$refs.amount.focus())
    },
    close() {
      this.$emit("close")
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$http.post("/secondary_market/", {
          // investment_account: this.currentInvestAccount.id,
          investment: this.investment.id,
          premium_or_discount: (this.amountPercentNum / 100).toFixed(2),
        }).then(() => {
          this.loading = false
          this.$auth.fetch()
          this.$store.commit('pushMessage', {
            icon: 'mdi-party-popper',
            text: [
              this.$t('startSelling.youHaveSuccessfullyPlaced', {
                referenceNumber: this.investment.loan.reference_number,
              }),
              ' ',
              { text: this.$t('startSelling.youHaveSuccessfullyPlacedLink'), to: '/account/documents' },
              '.',
            ],
            classHint: 'successfully-placed-on-secondary-market',
          })
          this.$emit("success", this.amount)
          this.$emit("close")
        }).catch(() => {
          this.loading = false
        })
      }
    },
  },
})
